<template>
  <dialog-form
    :value="value"
    @input="$emit('input', $event)"
    action="delete"
    :title="$localize('DeleteArticleCalculation.title')"
    @commit="save"
  >
    <p>{{$localize('DeleteArticleCalculation.description')}}</p>
    <p>{{$localize('form.description.actionIsPermanent')}}</p>
  </dialog-form>
</template>

<script>
import DialogForm from "@/shared/components/DialogForm";

import sendCommand from "@/services/sendCommand";
import { isGuid } from "@/services/validation"

export default {
  components: { DialogForm },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    articleCalculationId: {
      validator: isGuid
    }
  },

  methods: {
    async save(callback) {
      const result = await sendCommand("DeleteArticleCalculation", {
        articleCalculationId: this.articleCalculationId
      });

      if (result.success) {
        this.$emit("saved");
      }
      callback({ success: result.success });
    }
  }
};
</script>
